/**
 * Mirrors the backend `EmailProviderType`. The API serialises enums as their integers, so these
 * are the values that travel in both directions.
 */
export enum SmtpProvider {
  Smtp = 1,
  AmazonSes = 2
}

export interface SmtpConfigurationResponse {
  id: string;
  host: string;
  port: number;
  username: string;
  password: string;
  fromEmail: string;
  fromName: string;
  useSSL: boolean;
  isActive: boolean;
  provider: SmtpProvider;
  /** Only an Amazon SES account has one; `null` for plain SMTP. */
  sesConfigurationSet: string | null;
  createdAt: string;
  lastModified: string | null;
  createdByUserId: string | null;
  updatedByUserId: string | null;
  emailActionTypes: EmailActionType[];
}

export interface SmtpConfiguration {
  id: string;
  host: string;
  port: number;
  username: string;
  password: string;
  fromEmail: string;
  fromName: string;
  useSSL: boolean;
  isActive: boolean;
  provider: SmtpProvider;
  sesConfigurationSet: string | null;
  emailActionTypes: EmailActionType[];
}

export interface EmailActionType {
  id: string;
  name: string;
  //smtpAssignments: SmtpActionAssignment[];
}

export interface SmtpActionAssignment {
  id: string;
  smtpConfigId: string;
  smtpConfiguration: SmtpConfiguration;
  emailActionTypeId: string;
  emailActionType: EmailActionType;
}

/** A configuration that has not been stored yet, so it has no id to send. */
export type NewSmtpConfiguration = Omit<SmtpConfiguration, 'id'>;

/**
 * What the test-email endpoint needs to reach a server; it stores nothing. `sendTo` is where the
 * test lands — left out or null, the endpoint mails the From address.
 */
export type SmtpTestEmailPayload = Pick<
  SmtpConfiguration,
  'host' | 'port' | 'username' | 'password' | 'fromEmail' | 'fromName' | 'useSSL' | 'provider' | 'sesConfigurationSet'
> & { sendTo?: string | null };
